import React from 'react';
import '../Styles/inputStyle.css';

export function InputWithLabel({ divClassName = "", divStyle = "", labelID = "", inputValue = "", labelClassName = "", labelText = "", labelStyle = {}, inputID = "", inputClassName = "", inputStyle = {}, inputType = "", inputOptionalParams = {} }) 
{
    divStyle = typeof divStyle === 'string' ? { someStyleProperty: divStyle } : divStyle;

    return (
        <div className={"input-label-container " + divClassName} style={divStyle}>
            <label id={labelID} className={"input-label " + labelClassName} style={labelStyle}>{labelText}</label>
            <input
                id={inputID}
                className={inputClassName}
                type={inputType}
                style={inputStyle}
                defaultValue={inputValue}
                {...inputOptionalParams}
            />
        </div>
    );
}

export function Input({ inputID = "", inputClassName = "", inputStyle = {}, inputValue = "", inputType = "", inputOptionalParams = {} }) 
{
    return (
        <input
            id={inputID}
            className={inputClassName}
            type={inputType}
            style={inputStyle}
            defaultValue={inputValue}
            {...inputOptionalParams}
        />
    );
}

export function Textarea({ divClassName = "", divStyle = "", labelID = "", inputValue = "", labelClassName = "", labelText = "", labelStyle = {}, inputID = "", inputClassName = "", inputStyle = {}, inputType = "", inputOptionalParams = {} }) 
{
    divStyle = typeof divStyle === 'string' ? { someStyleProperty: divStyle } : divStyle;

    return (
        <div className={"input-label-container " + divClassName} style={divStyle}>
            <label id={labelID} className={"input-label " + labelClassName} style={labelStyle}>{labelText}</label>
            <textarea
                id={inputID}
                className={inputClassName}
                style={inputStyle}
                defaultValue={inputValue}
                {...inputOptionalParams}
            />
        </div>
    );
}

export function CheckBox({ chkID = "", chkClassName = "", chkStyle = {}, chkIndicatorStyle = {}, chkType = "", chkValue = false, chkText = "", inputOptionalParams = {} }) 
{
    return (
        <label className={"control control-checkbox text-start " + chkClassName} style={chkStyle}>
            {chkText}
            
            <input id={chkID} type={chkType} {...inputOptionalParams} defaultChecked={chkValue} />
            <div className="control_indicator" style={chkIndicatorStyle}></div>
        </label>
    );
}

export function Button({ btnID = "", btnClassName = "", btnStyle = {}, btnText = "", inputOptionalParams = {} }) 
{
    return (
        <button id={btnID} className={"button " + btnClassName} style={btnStyle} {...inputOptionalParams}>
            {btnText}
        </button>
    );
}